import React, { useState, useEffect } from 'react'
import { useFetch } from '../../hooks';
import { Card, CardHeader } from '../../components/Card';
import CardList from '../../components/Card/CardList';
import Buttons from '../../modules/Buttons';
import Button from '../../components/inputs/Button';
import Icon from '../../components/Icon';
import Note from '../Note'

const Diary = ({ id, endpointDiary, endpointNote, diary, disableAddNote }) => {
    const { doFetch } = useFetch({
        url: endpointDiary,
        method: 'POST',
        state: false
    })

    const [data, setData] = useState([]);
    const [nextID, setNextID] = useState();

    useEffect(() => {
        if (diary && diary.alerts) {
            setData(diary.alerts.data || [])
            setNextID(diary.alerts.nextid)
        }
    }, [diary])

    const handleClickNextID = async () => {
        try {
            const res = await doFetch({
                data: {
                    row_id: id,
                    nextid: nextID
                }
            })
            if (res.data) {
                setData(prevData => [...prevData, ...res.data])
            }
            setNextID(res.nextid)
        } catch (err) {
            console.log(err)
        }
    }
    return (
        <Card>
            <CardHeader>
                {diary.title}
            </CardHeader>
            <CardList
                data={data}
                urgent
                cmp={({ ...props }) => (
                    <Note
                        {...props}
                        endpointNote={endpointNote}
                        buttonsTranslation={{
                            submit: diary.alerts.buttons ? diary.alerts.buttons.save : '',
                            cancel: diary.alerts.buttons ? diary.alerts.buttons.cancel : ''
                        }}
                        setDiaryAlerts={setData}
                    />
                )}
                showOpenButton={!disableAddNote}
            />
            {nextID && (
                <Buttons centered>
                    <Button onClick={handleClickNextID} style={{ transform: 'rotate(90deg)' }} >
                        <Icon name="arrow" width="24" height="24" />
                    </Button>
                </Buttons>
            )}
        </Card>
    )
}

export default Diary